const ENAccessIP = {
	"Adicionar IP de acesso": "Add access IP",
	"Alterar IP de acesso": "Update access IP",
	"Configurar IP's de acesso": "Configure Access IP",
	"Deseja realmente excluir o endereço IP": "Do you really want to delete the IP address",
	"Endereço de IP": "IP address",
	"Endereço IP adicionado com sucesso": "IP address successfully added",
	"Endereço IP alterado com sucesso": "IP address successfully changed",
	"Endereço IP excluído com sucesso": "IP address successfully deleted",
	"Endereço IP é necessário": "IP address is required",
	"Endereço IP inválido": "Invalid IP address",
	"Erro ao adicionar endereço IP": "Error adding IP address",
	"Erro ao alterar endereço IP": "Error changing IP address",
	"Erro ao excluir endereço IP": "Error deleting IP address",
	"Exclusão de endereço IP": "Delete access IP",
	"IP de acesso": "Access IP",
	"IP's de Acesso": "Access IP",
	"No Cadastro de Usuário possui um configuração que permite escolher se deseja validar ou não o IP de acesso para cada usuário": "In the User Registration, there is a configuration that allows you to choose whether or not to validate the access IP for each user",
	"Seu IP é": "Your IP is",
	"Usuários do grupo Administradores não possuem restrição de IP": "Users in the Administrators group have no IP restriction"
};

export default ENAccessIP;
